<template>
  <el-container class="setContainer" :class="{ 'setContainer--report': enterId == '2' }">
    <el-header class="header_div" v-if="enterId != '2'">
      <i
        class="el-icon-back"
        style="float: left; font-size: 32px; line-height: 60px"
        @click="logoutAction"
      ></i>
      <strong style="margin: 0 auto" v-if="enterId == '4'"
        >设置 - 站点{{ station }}---(版本号：{{ version }})</strong
      >
      <!-- <strong style="margin: 0 auto;" v-if="enterId == '0'">日志管理</strong> -->
      <strong style="margin: 0 auto" v-if="enterId == '1'">会话统计</strong>
      <strong style="margin: 0 auto" v-if="enterId == '2'">数据统计分析</strong>
      <strong style="margin: 0 auto;" v-if="enterId == '3'">留言管理</strong>
      <strong style="margin: 0 auto" v-if="enterId == '5'">数据统计分析</strong>
      <strong style="margin: 0 auto" v-if="enterId == '6'">登录日志</strong>
    </el-header>
    <el-container v-if="enterId == '4'" style="height: 770px; border: none">
      <el-aside
        style="
          background-color: #ffffff;
          text-align: left;
          width: auto;
          border-radius: 0 0 0 1.25rem;
        "
      >
        <el-menu
          :default-openeds="['1', '2', '3', '4', '9']"
          style="border-right: 0"
          :default-active="activeIndex"
          router
          class="el-menu-vertical-demo"
        >
          <el-submenu
            index="1"
            v-if="$store.state.authority.personList.length > 0"
          >
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span class="nav_title">个人设置</span>
            </template>
            <el-menu-item
              v-for="(item, idx) in $store.state.authority.personList"
              :index="item.path"
              :key="idx"
              class="item_div"
              >{{ item.name }}</el-menu-item
            >
          </el-submenu>
          <el-submenu
            index="2"
            v-if="$store.state.authority.systemList.length > 0"
          >
            <template slot="title">
              <i class="el-icon-orange"></i>
              <span class="nav_title">系统设置</span>
            </template>
            <el-menu-item
              v-for="(item, idx) in $store.state.authority.systemList"
              :index="item.path"
              :key="idx"
              class="item_div"
              >{{ item.name }}</el-menu-item
            >
          </el-submenu>
          <el-submenu
            index="3"
            v-if="
              $store.state.authority.midmanList != undefined &&
              $store.state.authority.midmanList.length > 0
            "
          >
            <template slot="title">
              <i class="el-icon-orange"></i>
              <span class="nav_title">Middleman管理</span>
            </template>
            <el-menu-item
              v-for="(item, idx) in $store.state.authority.midmanList"
              :index="item.path"
              :key="idx"
              class="item_div"
              >{{ item.name }}</el-menu-item
            >
            <!-- <el-menu-item index="/setting/ruleset" class="item_div">规则配置</el-menu-item>
						<el-menu-item index="/setting/robotset" class="item_div">机器人引擎配置</el-menu-item>
						<el-menu-item index="/setting/monitorset" class="item_div">服务监控</el-menu-item> -->
          </el-submenu>
          <el-submenu index="4" v-show="$store.state.authority.isShowBot">
            <template slot="title">
              <i class="el-icon-orange"></i>
              <span class="nav_title">开口机器人</span>
            </template>
            <el-menu-item index="/setting/simplemodel" class="item_div"
              >简单模型</el-menu-item
            >
            <!-- <el-menu-item index="/setting/multimodeutter" class="item_div"
              >多话术模式</el-menu-item
            > -->
            <!-- <el-submenu index="3-2"> -->
            <!-- <template slot="title"><span class="item_div">编辑模型</span></template> -->
            <!-- <el-menu-item index="/setting/simplemodel" class="item_div">简单模型</el-menu-item> -->
            <!-- <el-menu-item index="/setting/indeterminate" :disabled="$store.state.AIstatus=='1'?false:true" class="item_div">待定语料</el-menu-item>
							<el-menu-item index="/setting/corpus" :disabled="$store.state.AIstatus=='1'?false:true" class="item_div">语料标注</el-menu-item>
							<el-menu-item index="/setting/edit" :disabled="$store.state.AIstatus=='1'?false:true" class="item_div">话术编辑</el-menu-item>
							<el-menu-item index="/setting/estimate" class="item_div">自动评估</el-menu-item> -->
            <!-- </el-submenu> -->
            <!-- <el-menu-item index="/setting/testrobot" class="item_div">测试</el-menu-item> -->
          </el-submenu>
          <el-submenu
            index="9"
            v-if="
              $store.state.authority.loginmg != undefined &&
              $store.state.authority.loginmg.length > 0
            "
          >
            <template slot="title">
              <i class="el-icon-orange"></i>
              <span class="nav_title">登录管理</span>
            </template>
            <el-menu-item
              v-for="(item, idx) in $store.state.authority.loginmg"
              :index="item.path"
              :key="idx"
              class="item_div"
              >{{ item.name }}</el-menu-item
            >
            <!-- <el-menu-item index="/setting/ruleset" class="item_div">规则配置</el-menu-item>
            <el-menu-item index="/setting/robotset" class="item_div">机器人引擎配置</el-menu-item>
            <el-menu-item index="/setting/monitorset" class="item_div">服务监控</el-menu-item> -->
          </el-submenu>
        </el-menu>
      </el-aside>

      <div class="gray_line"></div>

      <el-main style="border-radius: 0 0 20px 0">
        <router-view></router-view>
      </el-main>
    </el-container>

    <!-- <el-container v-else-if="enterId === '0'" style="height: 770px; border: none;">
			<logging-manager></logging-manager>
		</el-container> -->
    <el-container
      v-else-if="enterId === '1'"
      style="height: 770px; border: none"
    >
      <chatReport></chatReport>
    </el-container>
    <el-container
      v-else-if="enterId === '2'"
      class="report-view-container"
    >
      <chatForm></chatForm>
    </el-container>
    <el-container v-else-if="enterId === '3'" style="height: 770px; border: none;">
			<MsgManager></MsgManager>
		</el-container>
    <el-container
      v-else-if="enterId === '5'"
      style="height: 770px; border: none"
    >
      <Statistics></Statistics>
    </el-container>

    <el-container
      v-else-if="enterId === '6'"
      style="height: 770px; border: none"
    >
      <LoginLog></LoginLog>
    </el-container>
  </el-container>
</template>

<script>
// import screenfull from "screenfull"
// import loggingManager from './systemsetting/LoggingManager.vue'
import MsgManager from './systemsetting/MsgManager.vue'
import chatReport from "./chatReport.vue";
import chatForm from "./reportform/chatForm.vue";
import Statistics from "./reportStatistics.vue";
import LoginLog from "./loginLog.vue";
// import screenFullBtn from '../components/screenFullBtn.vue'
export default {
  name: "settings",

  components: {
    // loggingManager,
     MsgManager,
    chatReport,
    chatForm,
    Statistics,
    LoginLog,
    // screenFullBtn
  },

  data() {
    return {
      station: "",
      personList: [],
      systemList: [],
      activeIndex: "",
      version: "",
      enterId: this.$route.query.enterId,
      canotEditModel: false,
      AIstatus: this.$store.state.AIstatus,
      screenFull: true,
      screenBtn: "最大化",
      screenFullSrc1: require("../../static/talks/icon_fullscreen1.png"),
      screenFullSrc2: require("../../static/talks/icon_fullscreen2.png"),
      screenFullSrc3: require("../../static/talks/icon_fullscreen3.png"),
      screenFullSrc4: require("../../static/talks/icon_fullscreen4.png"),
      seenter: false,
    };
  },

  mounted() {
    console.log("settings mounted router = ", this.$route);
    console.log("settings mounted query = ", this.$route.query);
    this.version = localStorage.getItem("version");
    console.log("settings mounted enterid = ", this.enterId);
    console.log("settings mounted settingList = ", this.$store.state.authority);
    let site = this.util.getLocalSite();
    this.station = site.webId;
    this.activeIndex = "";

    if (this.enterId === undefined) {
      this.enterId = "4";
    }

    if (this.enterId === "4") {
      var personSetList = this.$store.state.authority.personList;
      console.log("setting personSetList = ", personSetList);
      if (personSetList.length > 0) {
        const setting = personSetList[0];
        this.activeIndex = setting.path;
        this.$router.push(setting.path);
      }
    }

    if (this.$store.state.AIstatus == "1") {
      this.canotEditModel = false;
    } else {
      this.canotEditModel = true;
    }
  },

  watch: {
    AIstatus(newVal, oldVal) {
      console.log("oldAIstatus", oldVal);
      console.log("newAIstatus", newVal);
      this.AIstatus = newVal;
      if (this.AIstatus == "1") {
        this.canotEditModel = false;
      } else {
        this.canotEditModel = true;
      }
    },
  },
  created() {
    // window.addEventListener('resize', this.onresize)
    // window.addEventListener('keydown', this.keydown)
  },
  beforeDestroy() {
    // 页面销毁时关闭ws。因为有可能ws连接接收数据尚未完成，用户就跳转了页面
    // 在需要主动关闭ws的地方都可以调用该方法
    // closeWebsocket()
    // window.removeEventListener('resize', this.onresize)
    // window.removeEventListener('keydown', this.keydown)
  },

  methods: {
    logoutAction() {
      console.log("settings logoutAction");
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("electron/") > -1) {
        //打包版本
        window.close();
      } else {
        //浏览器版本
        this.$router.push("/home");
      }
      //this.$router.push('/home')
      // window.close();
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.setContainer {
  width: 100%;
  height: 100vh;
  // background: #FFFFFF;
  background: #f7fbf7;
  margin: 0 auto;
  /* border-radius: 1.25rem; */
  /* margin-top: 5rem; */
  display: flex;
  flex-direction: row;
}

.setContainer--report {
  flex-direction: column;
}

.report-view-container {
  flex: 1;
  height: 100%;
  width: 100%;
  border: none;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.header_div {
  @include change_title_size($title_size_normal);
  text-align: center;
  height: 4rem;
  color: white;
  display: flex;
  align-items: center;
  background-color: #409eff;
}

.el-aside {
  color: #333;
}

.el-main {
  background-color: white;
}

.gray_line {
  width: 4px;
  height: 100%;
  background: #e2e8f0;
}

.nav_title {
  @include change_size($font_size_normal);
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #444444;
  margin-left: -3px;
}

.el-icon-orange,
.el-icon-setting {
  margin-left: -8px;
}

.item_div {
  @include change_size($font_size_normal);
  font-family: "arial, helvetica, sans-serif";
}

html[data-compact="1"] {
  .setContainer ::v-deep .el-header {
    height: 40px !important;
    padding: 0 10px;
    line-height: 40px;
  }
  .header_div {
    height: 40px !important;
  }
  .header_div .el-icon-back {
    font-size: 20px !important;
    line-height: 40px !important;
  }
  .header_div strong {
    font-size: 14px !important;
  }
}
</style>
